module.exports = __webpack_public_path__ + "static/infinum-bw-68daae992b82014c7715660a418e69b3.jpg";